// NeverFall shared interactions.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.nf-dropdown').forEach(function (dropdown) {
    var trigger = dropdown.querySelector(':scope > a');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      dropdown.classList.toggle('open');
    });

    document.addEventListener('click', function (event) {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('open');
      }
    });
  });

  var hamburger = document.getElementById('nf-hamburger');
  var mobileNav = document.getElementById('nf-mobile-nav');

  function closeMobileNav() {
    if (!mobileNav) return;

    mobileNav.classList.remove('open');

    if (hamburger) {
      hamburger.textContent = '☰';
    }
  }

  window.nfCloseMobileNav = closeMobileNav;

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      hamburger.textContent = mobileNav.classList.contains('open')
        ? '✕'
        : '☰';
    });

    document.addEventListener('click', function (event) {
      if (
        !hamburger.contains(event.target) &&
        !mobileNav.contains(event.target)
      ) {
        closeMobileNav();
      }
    });
  }

  function initOverlayA11y(panel, closeFn) {
    if (!panel) return;

    closeFn = closeFn || function () {
      panel.classList.remove('open');
    };

    var lastFocused = null;
    var keyHandler = null;

    function getFocusable() {
      return Array.prototype.slice.call(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function onKeydown(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        closeFn();
        return;
      }

      if (event.key !== 'Tab' && event.keyCode !== 9) {
        return;
      }

      var focusable = getFocusable();
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    var observer = new MutationObserver(function () {
      var isOpen = panel.classList.contains('open');

      if (isOpen) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');

        lastFocused = document.activeElement;

        var focusable = getFocusable();
        if (focusable.length) {
          focusable[0].focus();
        }

        keyHandler = onKeydown;
        document.addEventListener('keydown', keyHandler);
      } else {
        if (keyHandler) {
          document.removeEventListener('keydown', keyHandler);
          keyHandler = null;
        }

        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }
    });

    observer.observe(panel, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  initOverlayA11y(mobileNav, closeMobileNav);

  document.querySelectorAll('[data-nf-kit-finder]').forEach(function (panel) {
    initOverlayA11y(panel);
  });

  document.querySelectorAll('.nf-faq-q').forEach(function (button) {
    button.addEventListener('click', function () {
      var answer = button.nextElementSibling;
      var isOpen = button.classList.contains('open');
      var list = button.closest('.nf-faq-list');

      if (list) {
        list.querySelectorAll('.nf-faq-q').forEach(function (question) {
          question.classList.remove('open');
          question.nextElementSibling.style.display = 'none';
        });
      }

      if (!isOpen) {
        button.classList.add('open');
        answer.style.display = 'block';
      }
    });
  });

  document.querySelectorAll('[data-nf-review-carousel]').forEach(function (root) {
    var track = root.querySelector('.nf-rev-track');
    var previous = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');

    if (!track) return;

    var cards = track.querySelectorAll('.nf-rev-card');
    var index = 0;

    function visibleCount() {
      return window.innerWidth <= 768 ? 1 : 3;
    }

    function update() {
      var visible = visibleCount();
      if (!cards.length) return;

      var cardWidth = cards[0].offsetWidth + 24;

      index = Math.max(
        0,
        Math.min(index, cards.length - visible)
      );

      track.style.transform =
        'translateX(-' + index * cardWidth + 'px)';

      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index >= cards.length - visible;
    }

    if (previous) {
      previous.addEventListener('click', function () {
        index -= 1;
        update();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        index += 1;
        update();
      });
    }

    window.addEventListener('resize', update);
    update();

    var startX = 0;
    var wrapper = root.querySelector('.nf-rev-track-wrap');

    if (wrapper) {
      wrapper.addEventListener(
        'touchstart',
        function (event) {
          startX = event.touches[0].clientX;
        },
        { passive: true }
      );

      wrapper.addEventListener(
        'touchend',
        function (event) {
          var difference =
            startX - event.changedTouches[0].clientX;

          if (Math.abs(difference) > 40) {
            index += difference > 0 ? 1 : -1;
            update();
          }
        },
        { passive: true }
      );
    }
  });

  document.querySelectorAll('[data-nf-mob-carousel]').forEach(function (root) {
    var track = root.querySelector('.nf-mob-carousel__track');
    if (!track) return;

    var dots = root.querySelectorAll('.nf-mob-carousel__dot');
    var slides = track.querySelectorAll('.nf-mob-carousel__slide');
    var total = slides.length;
    var current = 0;
    var startX = 0;
    var autoTimer;

    if (!total) return;

    function slideOffset(element) {
      var offset = 0;
      var sibling = element.previousElementSibling;

      while (sibling) {
        offset += sibling.getBoundingClientRect().width;
        sibling = sibling.previousElementSibling;
      }

      return offset;
    }

    function goTo(index) {
      current = Math.max(0, Math.min(total - 1, index));

      track.style.transform =
        'translateX(-' + slideOffset(slides[current]) + 'px)';

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('active', dotIndex === current);
      });
    }

    function goToWrapped(index) {
      goTo((index + total) % total);
    }

    function startAuto() {
      clearInterval(autoTimer);

      autoTimer = setInterval(function () {
        goToWrapped(current + 1);
      }, 4000);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.dataset.slide));
        startAuto();
      });
    });

    var previous = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');

    if (previous) {
      previous.addEventListener('click', function () {
        goToWrapped(current - 1);
        clearInterval(autoTimer);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goToWrapped(current + 1);
        clearInterval(autoTimer);
      });
    }

    track.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchend',
      function (event) {
        var difference =
          startX - event.changedTouches[0].clientX;

        if (Math.abs(difference) > 40) {
          goToWrapped(difference > 0 ? current + 1 : current - 1);
          startAuto();
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      goTo(current);
    });

    goTo(0);
    startAuto();
  });

  document.querySelectorAll('[data-nf-kit-finder]').forEach(function (panel) {
    function showStep(id) {
      panel.querySelectorAll('.nf-kf-step').forEach(function (step) {
        step.classList.remove('active');
      });

      var target = panel.querySelector('#' + id);

      if (target) {
        target.classList.add('active');
      }

      panel.scrollTop = 0;
    }

    panel.querySelectorAll('[data-kf-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        var choices = button.closest('.nf-kf-choices');

        if (choices) {
          choices.querySelectorAll('.nf-kf-choice').forEach(function (choice) {
            choice.classList.remove('selected');
          });
        }

        button.classList.add('selected');

        var destination = button.getAttribute('data-kf-choice');

        setTimeout(function () {
          showStep(destination);
        }, 320);
      });
    });

    panel.querySelectorAll('[data-kf-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        showStep(button.getAttribute('data-kf-back'));
      });
    });

    panel.querySelectorAll('[data-kf-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        panel.classList.remove('open');
      });
    });

    panel.querySelectorAll('[data-kf-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        showStep('kf-q1');
        panel.classList.add('open');
      });
    });
  });

  // Product gallery and variant synchronization.
  document.querySelectorAll('[data-nf-gallery]').forEach(function (gallery) {
    var mainImage = gallery.querySelector('[data-nf-gallery-main]');

    function selectVariant(variantId) {
      if (!variantId) return;

      var scope = gallery.closest('.nf-product') || document;
      var select = scope.querySelector('[data-nf-variant-select]');

      if (select && select.value !== variantId) {
        select.value = variantId;
        select.dispatchEvent(new Event('change'));
      }
    }

    if (mainImage) {
      mainImage.addEventListener('click', function () {
        selectVariant(mainImage.getAttribute('data-variant-id'));
      });
    }

    gallery.querySelectorAll('[data-nf-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-nf-gallery-thumb]').forEach(function (item) {
          item.classList.remove('active');
        });

        thumb.classList.add('active');

        var source = thumb.getAttribute('data-src');
        var variantId = thumb.getAttribute('data-variant-id');

        if (source && mainImage) {
          mainImage.src = source;
        }

        if (mainImage && variantId) {
          mainImage.setAttribute('data-variant-id', variantId);
        }

        selectVariant(variantId);
      });
    });
  });

  // Variant select updates price, image, note, Buy button, and active thumbnail.
  document.querySelectorAll('[data-nf-variant-form]').forEach(function (form) {
    var scope = form.closest('.nf-product') || form;
    var select = form.querySelector('[data-nf-variant-select]');
    var priceElement = form.querySelector('[data-nf-variant-price]');
    var atcPriceElement = form.querySelector('[data-nf-variant-atc-price]');
    var noteElement = form.querySelector('[data-nf-variant-note]');
    var imageElement = scope.querySelector('[data-nf-variant-image]');
    var idInput = form.querySelector('[data-nf-variant-id]');

    if (!select) return;

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function update() {
      var option = select.options[select.selectedIndex];

      if (!option) return;

      if (idInput) {
        idInput.value = option.value;
      }

      if (priceElement && option.dataset.price) {
        priceElement.textContent = money(option.dataset.price);
      }

      if (atcPriceElement && option.dataset.price) {
        atcPriceElement.textContent = money(option.dataset.price);
      }

      if (noteElement && option.dataset.note) {
        noteElement.textContent = option.dataset.note;
      }

      if (imageElement && option.dataset.image) {
        imageElement.src = option.dataset.image;
      }

      if (imageElement) {
        imageElement.setAttribute('data-variant-id', option.value);
      }

      scope.querySelectorAll('[data-nf-gallery-thumb]').forEach(function (thumb) {
        thumb.classList.toggle(
          'active',
          thumb.getAttribute('data-variant-id') === option.value
        );
      });

      var submitButton = form.querySelector('[data-nf-variant-atc]');

      if (submitButton) {
        submitButton.disabled = option.dataset.available === 'false';
      }
    }

    select.addEventListener('change', update);
    update();
  });

  // Bracket quantity surcharge note.
  document.querySelectorAll('[data-nf-qty-note]').forEach(function (wrapper) {
    var quantityInput = wrapper.querySelector('[data-nf-qty-input]');
    var noteElement = wrapper.querySelector('[data-nf-surcharge-note]');

    if (!quantityInput || !noteElement) return;

    function update() {
      var quantity = parseInt(quantityInput.value, 10) || 1;

      if (quantity <= 2) {
        noteElement.textContent =
          'Orders of 2 or fewer brackets include a $3 small-order surcharge, added at checkout. Order 3 or more to avoid it.';
      } else {
        noteElement.textContent =
          'No small-order surcharge on this order — orders of 3 or more avoid the +$3 fee.';
      }
    }

    quantityInput.addEventListener('input', update);
    quantityInput.addEventListener('change', update);
    update();
  });
});